import { render, staticRenderFns } from "./checkboxMatchMaking.vue?vue&type=template&id=cc9e84e6&scoped=true"
import script from "./checkboxMatchMaking.vue?vue&type=script&lang=js"
export * from "./checkboxMatchMaking.vue?vue&type=script&lang=js"
import style0 from "./checkboxMatchMaking.vue?vue&type=style&index=0&id=cc9e84e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9e84e6",
  null
  
)

export default component.exports